import {
    GET_QUOTES_SUCCESS,
    GET_QUOTES_FAIL,
    GET_QUOTE_DETAIL_SUCCESS,
    GET_QUOTE_DETAIL_FAIL,
    ADD_NEW_QUOTE_SUCCESS,
    ADD_NEW_QUOTE_FAIL,
    UPDATE_QUOTE_SUCCESS,
    UPDATE_QUOTE_FAIL,
    DELETE_QUOTE_SUCCESS,
    DELETE_QUOTE_FAIL,
    CONVERT_QUOTE_TO_INVOICE_SUCCESS,
    CONVERT_QUOTE_TO_INVOICE_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    quotes: [],
    quoteDetail: {},
    error: {},
    loading: false
}

const QuoteReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_QUOTES_SUCCESS:
            return {
                ...state,
                quotes: action.payload.data || action.payload,
            }

        case GET_QUOTES_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_QUOTE_DETAIL_SUCCESS:
            return {
                ...state,
                quoteDetail: action.payload,
            }

        case GET_QUOTE_DETAIL_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_NEW_QUOTE_SUCCESS:
            return {
                ...state,
                quotes: [...state.quotes, action.payload],
            }

        case ADD_NEW_QUOTE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_QUOTE_SUCCESS:
            return {
                ...state,
                quotes: state.quotes.map(quote =>
                    quote.id.toString() === action.payload.id.toString()
                        ? { quote, ...action.payload }
                        : quote
                ),
            }

        case UPDATE_QUOTE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_QUOTE_SUCCESS:
            return {
                ...state,
                quotes: state.quotes.filter(
                    quote => quote.id.toString() !== action.payload.toString()
                ),
            }

        case DELETE_QUOTE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case CONVERT_QUOTE_TO_INVOICE_SUCCESS:
            return {
                ...state,
                // On pourrait marquer le devis comme accepté ici dans la liste si besoin
                quotes: state.quotes.map(q =>
                    q.id === action.payload.quote_id ? { ...q, status: 'accepted' } : q
                )
            }

        default:
            return state
    }
}

export default QuoteReducer
